import { serializeURLSearchParamsStably } from 'src/adapters/storeToPageURL/builders/serializeURLSearchParamsStably';
import { buildListingsURLFromState } from 'src/adapters/storeToPageURL/state/buildListingsURLFromState';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

const normalizeAsPathForCompare = (asPath: string): string => {
  const queryStringIndex = asPath.indexOf('?');
  const pathnameWithoutQuery = queryStringIndex === -1 ? asPath : asPath.slice(0, queryStringIndex);
  if (queryStringIndex === -1) {
    return pathnameWithoutQuery;
  }
  const stableQueryString = serializeURLSearchParamsStably(
    new URLSearchParams(asPath.slice(queryStringIndex + 1)),
  );
  return stableQueryString ? `${pathnameWithoutQuery}?${stableQueryString}` : pathnameWithoutQuery;
};

export const productsQueryMatchesURL = (asPath: string, state: ReduxApplicationState): boolean =>
  normalizeAsPathForCompare(asPath) === normalizeAsPathForCompare(buildListingsURLFromState(state));
